import { render } from "./StateSwitch.vue?vue&type=template&id=1b0094d9&scoped=true"
import script from "./StateSwitch.vue?vue&type=script&lang=js"
export * from "./StateSwitch.vue?vue&type=script&lang=js"

import "./StateSwitch.vue?vue&type=style&index=0&id=1b0094d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0094d9"]])

export default __exports__